import { PlayIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeToConfirmModal from '../../../../../components/common/modals/TypeToConfirmModal';
import TableSelectionPanel, {
  TableSelectionPanelProps,
} from '../../../../../components/dataTable/components/TableSelectionPanel';
import CopyIcon from '../../../../../components/icons/CopyIcon';
import TrashIcon from '../../../../../components/icons/TrashIcon';
import { colors } from '../../../../../styles/variables';
import { CallbackDefault } from '../../../../../types/Types';

interface TemplatesListTableSelectionPanelProps extends Omit<TableSelectionPanelProps, 'children'> {
  onStartGame: CallbackDefault;
  onDuplicate: CallbackDefault;
  onDelete: CallbackDefault;
  hideStartGame?: boolean;
  hideDuplicate?: boolean;
  isLoadingDelete: boolean;
}

const TemplatesListTableSelectionPanel = (props: TemplatesListTableSelectionPanelProps) => {
  const { onStartGame, onDuplicate, onDelete, hideStartGame, hideDuplicate, isLoadingDelete } = props;
  const { t } = useTranslation();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <TableSelectionPanel {...props}>
        {!hideStartGame && (
          <button onClick={onStartGame} className="text-red700 font-semibold text-sm flex items-center gap-1.5">
            <PlayIcon color={colors.red700} width={16} />
            {t('templates.table.selectionPanel.startGame')}
          </button>
        )}

        {!hideDuplicate && (
          <button onClick={onDuplicate} className="text-red700 font-semibold text-sm flex items-center gap-1.5">
            <CopyIcon color={colors.red700} width={16} />
            {t('templates.table.selectionPanel.duplicate')}
          </button>
        )}

        <button
          onClick={() => setIsDeleteModalOpen(true)}
          className="text-red700 font-semibold text-sm flex items-center gap-1.5"
        >
          <TrashIcon color={colors.red700} width={16} />
          {t('templates.table.selectionPanel.delete')}
        </button>
      </TableSelectionPanel>

      <TypeToConfirmModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        textToType={t('templates.table.selectionPanel.deleteModal.textToType')}
        title={t('templates.table.selectionPanel.deleteModal.title')}
        confirmBtnText={t('templates.table.selectionPanel.deleteModal.confirmBtnText')}
        confirmBtnAction={onDelete}
        cancelBtnText={t('templates.table.selectionPanel.deleteModal.cancelBtnText')}
        isConfirmBtnDisabled={isLoadingDelete}
        isConfirmBtnLoading={isLoadingDelete}
        confirmBtnIcon={<TrashIcon color={colors.white900} />}
      />
    </>
  );
};

export default TemplatesListTableSelectionPanel;
